import React, { createContext, ReactNode, useContext, useState } from "react";

// Define the shape of the context
interface NonAuthenticatedContextType {
  username: string;
  setUsername: React.Dispatch<React.SetStateAction<string>>;
}

// Create the context with a default value
const NonAuthenticatedContext = createContext<NonAuthenticatedContextType | undefined>(undefined);

// Props for the provider component
interface NonAuthenticatedProviderProps {
  children: ReactNode;
}

// Provider implementation
export const NonAuthenticatedProvider: React.FC<NonAuthenticatedProviderProps> = ({ children }: { children: any }) => {
  const [username, setUsername] = useState("");
  return (
    <NonAuthenticatedContext.Provider
      value={{
        username,
        setUsername,
      }}
    >
      {children}
    </NonAuthenticatedContext.Provider>
  );
};

// hook to use context
export const useNonAuthenticated = (): NonAuthenticatedContextType => {
  const context = useContext(NonAuthenticatedContext);
  if (!context) {
    throw new Error("useNonAuthenticated must be used within a NonAuthenticatedProvider");
  }
  return context;
};
